import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (!username || !password) {
      setError('Please enter both username and password');
      setLoading(false);
      return;
    }

    const result = await login(username, password);
    
    if (!result.success) {
      setError(result.error);
    }
    // Navigation is handled by App.js through AuthContext
    
    setLoading(false);
  };

  return (
    <div className="container" style={{ justifyContent: 'center' }}>
      <div style={{ width: '100%' }}>
        {/* Logo */}
        <div className="page-header">
          <div style={{ 
            width: '100px', 
            height: '100px', 
            backgroundColor: '#1f84f1', 
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 24px',
            boxShadow: '0 4px 20px rgba(31, 132, 241, 0.3)'
          }}>
            <span style={{ fontSize: '40px' }}>✨</span>
          </div>
          <h1 className="page-title">Cosmic Profile</h1>
          <p className="page-subtitle">Your Personalized Astrological Frame</p>
        </div>

        {/* Login Form */}
        <form onSubmit={handleSubmit} autoComplete="off">
          <div className="form-group">
            <label className="form-label">Username</label>
            <input
              type="text"
              className="form-input"
              placeholder="Enter your username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="off"
              name="login_empid"
              spellCheck={false}
            />
          </div>

          <div className="form-group">
            <label className="form-label">Password</label>
            <input
              type="password"
              className="form-input"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="new-password"
              name="login_secret"
            />
          </div>

          {error && <p className="error-message">{error}</p>}

          <button
            type="submit"
            className="btn btn-primary"
            disabled={loading}
            style={{ marginTop: '24px' }}
          >
            {loading ? (
              <>
                <span className="spinner" style={{ marginRight: '8px', width: '20px', height: '20px' }}></span>
                Signing in...
              </>
            ) : (
              'Sign In'
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
